<template>
  <div>
    <job-menu :job="job"></job-menu>

    <div class="px-4 my-10">
      <div class="flex items-center justify-center">
        <h1 class="w-full mb-5 text-3xl font-bold text-center md:mb-0 md:w-auto">
          {{ __("Job notification") }}
        </h1>
      </div>

      <div class="p-4 mt-10 bg-white shadow-md">
        <div class="max-w-5xl p-10 mx-auto">

          <div class="mb-10">
            <h3 class="text-xl font-bold">{{ __("Details") }}</h3>
            <div class="mt-4">
              <div class="mb-2">
                {{ request.user.name }} - {{ request.created_at }}
              </div>
              <div class="mb-2" v-if="request.responded_at">
                {{ __("Responded at") }}:{{ request.responded_at }}
              </div>
            </div>
          </div>

          <div class="mb-10">
            <h3 class="text-xl font-bold">{{ __("Client") }}</h3>
            <div class="mt-4">
              <div>
                {{ request.client.name }} - {{ request.client.phone }}
              </div>
            </div>
          </div>

          <div class="mb-10">
            <h3 class="text-xl font-bold">{{ __("Message") }}</h3>
            <div class="mt-4">
              <div>
                {{ request.content }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import Layout from '@/Shared/Layout';
  import JobMenu from "../Jobs/JobMenu";

  export default {
    layout: Layout,
    metaInfo() {
      return {
        title: this.__("Job notification")
      }
    },
    props: {
      job: Object,
      request: Object,
    },
    components: {
      Layout,
      JobMenu
    }
  }
</script>
